import React from "react";
import axios from "axios";
import PropTypes from "prop-types";

import Util from "../../../util";
import CatalogFull from "./Templates/CatalogFull";
import CatalogNavigation from "./Templates/CatalogNavigation";
import Collection from "../Catalog/Collection";
import Carousel from "../Catalog/Carousel";
import CatalogItem from "../Catalog/Item";
import TrackVisibility from "react-on-screen";

const templates = {
    "catalog-full": CatalogFull,
    "catalog-navigation": CatalogNavigation,
    carousel: Carousel,
    grid: Collection
};

class ProductWidget extends React.Component {
    constructor(props) {
        super(props);
        this.fetchProducts = this.fetchProducts.bind(this);
        this.fetchSolrProducts = this.fetchSolrProducts.bind(this);
        this.parseDynamicValues = this.parseDynamicValues.bind(this);

        const solrFilters = this.parseDynamicValues(props.solrFilters);
        let filterGroups = this.addImageFilters(props.filterGroups);

        filterGroups = this.parseDynamicValues(filterGroups);

        this.state = {
            products: [],
            title: props.title,
            filterGroups: filterGroups,
            sortOrders: props.sortOrders,
            solrFilters: solrFilters,
            solrSort: props.solrSort,
            restUrl: props.restUrl
        };
    }
    addImageFilters(filter) {
        let parsedFilter = JSON.parse(filter);

        parsedFilter = parsedFilter.concat([
            {
                field: "image",
                value: "null",
                condition: "neq",
                logic: "and"
            },
            {
                field: "image",
                value: "no_selection",
                condition: "neq",
                logic: "and"
            },
            {
                field: "thumbnail",
                value: "null",
                condition: "neq",
                logic: "and"
            },
            {
                field: "thumbnail",
                value: "no_selection",
                condition: "neq",
                logic: "and"
            }
        ]);

        return JSON.stringify(parsedFilter);
    }
    parseDynamicValues(filter) {
        let parsedFilter = filter;

        let date = new Date();
        let currentDate = `${date.getFullYear()}-${date.getMonth() +
            1}-${date.getDate()}`;
        let currentCategory = localStorage.getItem("currentCategory");
        let productName = localStorage.getItem("productName");
        let productSeller = localStorage.getItem("productSeller");
        let productManufacturer = localStorage.getItem("productManufacturer");
        let productModel = localStorage.getItem("productModel");
        let productCondition = localStorage.getItem("productCondition");

        parsedFilter = parsedFilter.replace(
            /{{current_category}}/gi,
            currentCategory
        );
        parsedFilter = parsedFilter.replace(/{{current_date}}/gi, currentDate);
        parsedFilter = parsedFilter.replace(/{{product_name}}/gi, productName);
        parsedFilter = parsedFilter.replace(
            /{{product_seller}}/gi,
            productSeller
        );
        parsedFilter = parsedFilter.replace(
            /{{product_manufacturer}}/gi,
            productManufacturer
        );
        parsedFilter = parsedFilter.replace(
            /{{product_model}}/gi,
            productModel
        );
        parsedFilter = parsedFilter.replace(
            /{{product_condition}}/gi,
            productCondition
        );

        return parsedFilter;
    }
    componentDidMount() {
        this.setState({
            restUrl: localStorage.getItem("restUrl")
        });

        if (
            this.props.solrFilters &&
            (this.props.filterGroups == "[]" && this.props.sortOrders == "[]")
        ) {
            this.fetchSolrProducts();
        } else {
            this.fetchProducts();
        }
    }
    fetchProducts(isFallBack = false) {
        let query = `?pageSize=${this.props.pageSize * this.props.pageCount}`;
        let currentFilters = isFallBack
            ? this.props.fallBackFilterGroups
            : this.state.filterGroups;

        axios
            .get(
                `/api/products${query}&filterGroups=${currentFilters}&sortOrders=${
                    this.state.sortOrders
                }&fields=items[id,name,sku,status,image,thumbnail,price,condition,extension_attributes,custom_attributes]`
            )
            .then(response => {
                if (
                    !isFallBack &&
                    (this.props.fallBackFilterGroups ||
                        this.props.fallBackSolrFilters) &&
                    response.data.items.length <= this.props.fallBackLimit
                ) {
                    this.setState(
                        {
                            products: response.data.items
                        },
                        () => {
                            this.props.fallBackFilterGroups
                                ? this.fetchProducts(true)
                                : this.fetchSolrProducts(true);
                        }
                    );
                } else {
                    if (this.props.randomize) {
                        response.data.items = Util.shuffle(response.data.items);
                    }

                    this.setState({
                        products: [
                            ...this.state.products,
                            ...response.data.items
                        ],
                        title: isFallBack
                            ? this.props.fallBackTitle
                            : this.props.title
                    });
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
    fetchSolrProducts(isFallBack = false) {
        let query = `?pageSize=${this.props.pageSize * this.props.pageCount}`;
        let currentFilters = isFallBack
            ? this.props.fallBackSolrFilters
            : this.state.solrFilters;

        axios
            .get(
                `/api/solr${query}&filters=${currentFilters}&sort=${
                    this.state.solrSort
                }`
            )
            .then(solrResult => {
                if (
                    !isFallBack &&
                    (this.props.fallBackFilterGroups ||
                        this.props.fallBackSolrFilters) &&
                    solrResult.data.response.result.length <=
                        this.props.fallBackLimit
                ) {
                    this.setState(
                        {
                            products: solrResult.data.response.result
                        },
                        () => {
                            this.props.fallBackSolrFilters
                                ? this.fetchSolrProducts(true)
                                : this.fetchProducts(true);
                        }
                    );
                } else {
                    if (this.props.randomize) {
                        solrResult.data.response.result = Util.shuffle(
                            solrResult.data.response.result
                        );
                    }

                    this.setState({
                        products: [
                            ...this.state.products,
                            ...solrResult.data.response.result
                        ],
                        title: isFallBack
                            ? this.props.fallBackTitle
                            : this.props.title
                    });
                }
            })
            .catch(err => {
                console.error(err);
            });
    }
    render() {
        const Template = templates[this.props.template];

        if (this.state.products.length > 0) {
            return (
                <TrackVisibility offset={500} once>
                    {({ isVisible }) =>
                        isVisible && (
                            <div
                                className={`product-widget ${
                                    this.props.className
                                }`}>
                                <div className="product-widget-header d-flex justify-content-between">
                                    {this.state.title && (
                                        <h2 className="title">
                                            {this.state.title}
                                        </h2>
                                    )}
                                    {this.props.link && (
                                        <a
                                            className="primary-color align-self-center"
                                            href={this.props.link}>
                                            VIEW ALL{" "}
                                            <i className="far fa-angle-right" />
                                        </a>
                                    )}
                                </div>
                                <Template
                                    data={this.state.products}
                                    pageSize={this.props.pageSize}
                                    pageScroll={this.props.pageScroll}
                                    loop={this.props.loop}
                                    displayDots={this.props.displayDots}
                                    speed={this.props.speed}
                                    autoPlay={this.props.autoPlay}
                                    autoPlayInterval={
                                        this.props.autoPlayInterval
                                    }
                                    itemComponent={CatalogItem}
                                    className="product-grid"
                                    trackClicks={this.props.trackClicks}
                                    trackImpressions={this.props.trackImpressions}
                                    actionField={this.props.actionField}
                                    showSeller={this.props.showSeller}
                                    lazyLoad={this.props.lazyLoad}
                                    restUrl={this.state.restUrl}
                                />
                            </div>
                        )
                    }
                </TrackVisibility>
            );
        } else {
            return null;
        }
    }
}

ProductWidget.defaultProps = {
    className: "",
    template: "grid",
    pageSize: 4,
    pageCount: 3,
    pageScroll: 1,
    autoPlay: false,
    autoPlayInterval: 10000,
    speed: 500,
    loop: true,
    displayDots: true,
    filterGroups: "[]",
    sortOrders: "[]",
    fallBackLimit: 0,
    solrFilters: "{}",
    solrSort: "",
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl"),
    randomize: false,
    lazyLoad: true
};

ProductWidget.propTypes = {
    className: PropTypes.string,
    template: PropTypes.string,
    title: PropTypes.string.isRequired,
    pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    pageScroll: PropTypes.number,
    autoPlay: PropTypes.bool,
    autoPlayInterval: PropTypes.number,
    speed: PropTypes.number,
    loop: PropTypes.bool,
    displayDots: PropTypes.bool,
    filterGroups: PropTypes.string,
    fallBackFilterGroups: PropTypes.string,
    fallBackLimit: PropTypes.number,
    fallBackTitle: PropTypes.string,
    sortOrders: PropTypes.string,
    solrFilters: PropTypes.string,
    fallBackSolrFilters: PropTypes.string,
    solrSort: PropTypes.string,
    restUrl: PropTypes.string,
    randomize: PropTypes.bool,
    lazyLoad: PropTypes.bool,
    link: PropTypes.string,
    showSeller: PropTypes.bool,
    trackImpressions: PropTypes.bool,
    trackClicks: PropTypes.bool,
    actionField: PropTypes.string
};

export { ProductWidget };
